import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const DSPSelectorLoader: React.FC<{ className?: string }> = ({
  className,
}): any => (
  <ContentLoader width={450} height={200} className={className}>
    <rect width="100" height="13" x="0" y="11" />
    <rect width="150" height="35" x="0" y="38" />
    <rect width="450" height="100" x="0" y="100" />
  </ContentLoader>
);

export default DSPSelectorLoader;
